import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Rating,
  Typography,
  Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "./Header";
import axios from "axios";

// Sample Data
const sampleData = [
  {
    id: 1,
    name: "John Doe",
    phoneNumber: "9876543210",
    overallRating: 4,
    managerComments: "Great tenant",
    payOnTime: 5,
    cleanliness: 4,
    traffic: 3,
    noisy: 2,
  },
  {
    id: 2,
    name: "Jane Smith",
    phoneNumber: "1234567890",
    overallRating: 3,
    managerComments: "Often late on rent",
    payOnTime: 2,
    cleanliness: 3,
    traffic: 4,
    noisy: 3,
  },
  // Add more rows as needed
];

const renderStars = (params) => (
  <Rating value={params.value || 0} readOnly precision={0.5} size="small" />
);

const ReviewsReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [reviewsData, setReviewsData] = useState([]);

  useEffect(() => {
  
          getAllReviews();
       
     }, []);

  const filteredRows = reviewsData.filter((row) => {
    const target = `${row.name} ${row.phone}`.toLowerCase();
    return target.includes(searchTerm.toLowerCase());
  });

  const getAllReviews = async () => {
  try {
    const response = await axios.get(`/api/reviews`);
    if (response && response.data) {
      const resultArray = response.data.map((item) => ({
        ...item,
        name: `${item.fname || ""} ${item.lname || ""}`,
        phone: item.phone || item.phoneNumber || "", // ensure "phone" exists
      }));
      setReviewsData(resultArray);
    }
  } catch (error) {
    console.log(error);
  }
};

  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    {
      field: "overallRating",
      headerName: "Overall",
      flex: 1,
      renderCell: renderStars,
      sortable: false,
    },
    {
      field: "payOnTime",
      headerName: "Pay On Time",
      flex: 1,
      renderCell: renderStars,
      sortable: false,
    },
    {
      field: "cleanliness",
      headerName: "Cleanliness",
      flex: 1,
      renderCell: renderStars,
      sortable: false,
    },
    {
      field: "traffic",
      headerName: "Traffic",
      flex: 1,
      renderCell: renderStars,
      sortable: false,
    },
    {
      field: "noisy",
      headerName: "Noisy",
      flex: 1,
      renderCell: renderStars,
      sortable: false,
    },
    {
      field: "managerComments",
      headerName: "Manager Comments",
      flex: 2,
    },
  ];

  return (
    <>
    <Header/>
    <Box sx={{ height: "80vh", p: 2 }}>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          label="Search by Name or Phone"
          variant="outlined"
          fullWidth
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Stack>
      <DataGrid
        rows={filteredRows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10]}
        disableRowSelectionOnClick
        sx={{
          '& .MuiDataGrid-cell': {
            alignItems: 'center',
          },
        }}
      />
    </Box>
    </>
  );
};

export default ReviewsReport;
